import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

type Role = {
  _id: string;
  role: string;
}

const AddStaff = ({
  handleAddStaff,
  handleChange,
  handleSubmit,
  loading,
  sign,
}: any) => {

  const [roles, setRoles] = useState<Role[]>([]);
  const token = window.localStorage.getItem("token")


  const fetchRoles = () => {
    axios.get("https://apibiz.oneflaretech.com/api/roles",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => {
        setRoles(res.data.data)
      })
      .catch((err) => {
        toast.error(err.data.message)
      })
  }

  useEffect(() => {
    fetchRoles();
  }, [])


  return (
    <div className="modal">
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Add New Staff</h4>
          <ImCancelCircle className="catCancel" onClick={handleAddStaff} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <div className="div modalDouble">
            <input
              required
              type="text"
              placeholder="Staff’s First name"
              name="firstName"
              value={sign.firstName}
              onChange={handleChange}
            />
            <input
              required
              type="text"
              placeholder="Staff’s last name"
              name="lastName"
              value={sign.lastName}
              onChange={handleChange}
            />
          </div>
          <div className="div modalDouble">
            <input
              required
              type="text"
              placeholder="Staff’s email address"
              name="email"
              value={sign.email}
              onChange={handleChange}
            />
            <input
              required
              type="number"
              placeholder="Staff’s Phone Number"
              name="phone"
              value={sign.phone}
              onChange={handleChange}
            />
          </div>
          <input
            required
            type="text"
            placeholder="Staff’s Password"
            name="password"
            value={sign.password}
            onChange={handleChange}
          />
          <select
            name="role"
            value={sign.role}
            onChange={handleChange}
          >
            <option value="" disabled selected>Staff's role</option>
            {roles.map((role) => (
              <option key={role._id} value={role.role}>
                {role.role}
              </option>
            ))}
          </select>
          <input
            required
            type="text"
            placeholder="Address"
            name="address"
            value={sign.address}
            onChange={handleChange}
          />
          <div className="div modalDouble">
            <input
              required
              type="text"
              placeholder="City"
              name="city"
              value={sign.city}
              onChange={handleChange}
            />
            <input
              required
              type="tel"
              placeholder="State"
              name="state"
              value={sign.state}
              onChange={handleChange}
            />
          </div>
          <input
            required
            type="text"
            placeholder="Country"
            name="country"
            value={sign.country}
            onChange={handleChange}
          />
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Create"
            )}
          </button>
          <button className="catBtn2" onClick={handleAddStaff}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddStaff;
